import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import "./css/common.css";
// import Header from "./components/Header";
import Header from "./components/Header";
// import Footer from "./components/Footer";

import ScrollToTop from "react-scroll-up";
import React, { useEffect, useState,lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import {createStore} from 'redux';
import {Provider} from 'react-redux';
import nameReducer from './store/reducers';
import productData from "./includes/LoanProducts.json";
import WhlPageWrapper from "./components/WhlPageWrapper";
const Footer = lazy(() => import('./components/Footer'));
const renderLoader = () => <p>Loading...</p>;

const AppWrapper = () => {
  const store = createStore(nameReducer);

  return (
    <Provider store={store}>
      <App />
    </Provider>
  )
}

function App() {

  const [pageDetails, setPageDetails] = useState({
    pageName: '',
    loanProduct: ''
  })

  const loadWHLPageDetails = () => {
    // read env and make prop 'page' to be passed to diffnt pages

    // To get React App URL
    let loanProduct = `${process.env.REACT_APP_URL}`;

    //-- to get programe name
    const programName = productData[loanProduct].programName;
    const programDetails = productData[loanProduct];

    setPageDetails(state => {
      return {
        ...state,
        pageName: programName,
        loanProduct: loanProduct,
        programDetails: programDetails
      }
    })
    
  }
  
  useEffect(() => {
    loadWHLPageDetails()
  }, [])

  if(process.env.REACT_APP_TITLE === 'Chenoa DPA') {
    return <>
      <div className="App revamp">
        <Router basename={process.env.PUBLIC_URL}>
          <WhlPageWrapper pageDetails={pageDetails} />
        </Router>
        {/* <Suspense fallback={renderLoader()}>
        </Suspense> */}
        <ScrollToTop showUnder={160} style={{ transitionDuration: "0.6s" }}>
          <span className="back-to-top"></span>
        </ScrollToTop>
      </div>
    </>
  }
  
  return (
    <div className="App">
        <Router basename={process.env.PUBLIC_URL}>
          <Header />
          <WhlPageWrapper pageDetails = { pageDetails } />
        </Router>
        <Suspense fallback={renderLoader()}>
          <Footer />
        </Suspense>
      <ScrollToTop showUnder={160} style={{ transitionDuration: "0.6s" }}>
        <span className="back-to-top"></span>
      </ScrollToTop>
    </div>
  );
}

export default AppWrapper;
